/*
  nv-kaching.js — Lumeria advent calendar bundle bars (single-variant product).
  - Bars: 1 / 3 / 5 calendars (data-qty). Clicking a bar selects it and updates the top price line.
  - The theme's add to cart is rewritten to the product's variant with the selected bar's quantity; the
    automatic discounts (qty >= 3 / >= 5) make it Buy 2 Get 1 / Buy 3 Get 2 FREE.
  - Gifts (from config): data.gifts = [{id, min, props}] adds a $0 gift line when qty >= min;
    data.lineProps = [{min, props}] adds properties to the main line (e.g. a digital gift note).
  - Multi-variant products (e.g. eyeliner Black / Brown): data.variants = [{id, c}]. A shade picker sets the
    shade; bars with more than one unit show one shade select per unit, pre-filled from the top picker.
    Add to cart becomes one line per chosen variant (product-level discounts still count the total qty).
  - Two-option products (e.g. tights Color x Size): data.variants = [{id, c, s}]. Size buttons sit under the
    colour picker (no size pre-selected) with an optional size-chart dialog; bundle rows get a colour + size
    select per unit. Add to cart is refused (422 "Please choose your size") until every unit has a size.
  - Colour photos (variant featured images, data.variants[].m / .img): the gallery shows ONE colour photo, the selected
    colour's. The first colour photo's slot becomes the "colour slot" (its image swaps on every colour change, and the
    gallery jumps to it); the other colour photos' slots are hidden.
*/
(() => {
  if (window.__nvKaching) return;
  window.__nvKaching = true;

  const roots = () => [...document.querySelectorAll('.nv-kaching')];
  const dataOf = (root) => {
    if (!root._d) root._d = JSON.parse(root.querySelector('.nv-kaching-data').textContent);
    return root._d;
  };
  const bars = (root) => [...root.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id]')];
  const selectedBar = (root) => root.querySelector('.kaching-bundles__bar--selected') || bars(root)[0];
  const qtyOf = (root) => Number((selectedBar(root) || {}).dataset?.qty || 1);
  const multi = (root) => (dataOf(root).variants || []).length > 1;
  const esc = (t) => String(t).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
  const sized = (root) => (dataOf(root).variants || []).some((v) => v.s != null);
  const st = (root) => (root._s = root._s || { shade: (dataOf(root).variants || [])[0]?.c, size: null, units: [] });
  const vFor = (root, shade, size) => (dataOf(root).variants || []).find((v) => v.c === shade && (!sized(root) || v.s === size));
  const idFor = (root, shade, size) => (vFor(root, shade, size) || {}).id || dataOf(root).variant;
  const uniq = (a) => [...new Set(a)];
  const sizeList = (root) => uniq((dataOf(root).variants || []).map((v) => v.s).filter((x) => x != null));

  function syncHiddenId(root) {
    if (!multi(root)) return;
    const s = st(root);
    const id = idFor(root, s.shade, s.size || sizeList(root)[0]);
    const section = document.getElementById('shopify-section-' + root.dataset.sectionId) || document;
    section.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"], form[action*="/cart/add"] input[name="id"]').forEach((i) => { i.value = id; });
  }

  function renderUnits(root) {
    const box = root.querySelector('.elv-pairs');
    if (!box || !multi(root)) return;
    const s = st(root), q = qtyOf(root), d = dataOf(root);
    while (s.units.length < q) s.units.push({ c: s.shade, s: s.size });
    s.units.length = q;
    if (q < 2) { box.hidden = true; box.innerHTML = ''; return; }
    // the per-unit picker lives inside the selected bundle bar, right under its price
    const bar = selectedBar(root), host = bar && (bar.querySelector('.kaching-bundles__bar-wrapper') || bar);
    if (host && box.parentElement !== host) host.appendChild(box);
    box.hidden = false;
    if (s.active == null || s.active >= q) s.active = 0;
    const two = sized(root), on = d.optionName || 'Shade', sn = d.sizeName || 'Size';
    const unit = d.unitName || ((root.querySelector('.kaching-bundles__bar[data-qty="1"] .kaching-bundles__bar-subtitle') || {}).textContent || '').replace(/^\s*1\s*/, '').trim() || 'item';
    if (!two) {
      // one swatch row per unit: tap a dot to set that unit; tapping a shade above fills the highlighted row
      const shades = uniq(d.variants.map((v) => v.c));
      const dot = (c) => (root.querySelector(`.elv-shade[data-shade="${CSS.escape(c)}"] .elv-shade__dot`) || {}).style?.background || '#ccc';
      box.innerHTML = `<p class="elv-pairs__title">Pick a ${esc(on.toLowerCase())} for each ${esc(unit.toLowerCase())}</p>` +
        s.units.map((u, i) => `<div class="elv-pair elv-pair--dots${i === s.active ? ' is-active' : ''}" data-i="${i}"><span class="elv-pair__n">${i + 1}</span>` +
          `<div class="elv-dots" role="radiogroup" aria-label="${esc(on)} for ${esc(unit)} ${i + 1}">` +
          shades.map((c) => `<button type="button" class="elv-dot${c === u.c ? ' is-on' : ''}" data-c="${esc(c)}" role="radio" aria-checked="${c === u.c}" aria-label="${esc(c)}" title="${esc(c)}" style="background:${dot(c)}"></button>`).join('') +
          `</div><span class="elv-pair__name">${esc(u.c)}</span></div>`).join('');
      return;
    }
    const opts = (list, sel, ph) => (ph ? `<option value="">${esc(ph)}</option>` : '') + list.map((x) => `<option value="${esc(x)}"${x === sel ? ' selected' : ''}>${esc(x)}</option>`).join('');
    box.innerHTML = `<p class="elv-pairs__title">Choose a ${esc(on.toLowerCase())} &amp; ${esc(sn.toLowerCase())} for each</p>` +
      s.units.map((u, i) => `<div class="elv-pair elv-pair--cs" data-i="${i}"><span class="elv-pair__n">#${i + 1}</span>` +
        `<select data-k="shade" aria-label="${esc(on)} for #${i + 1}">${opts(uniq(d.variants.map((v) => v.c)), u.c)}</select>` +
        `<select data-k="size" aria-label="${esc(sn)} for #${i + 1}">${opts(sizeList(root), u.s, sn)}</select></div>`).join('');
  }


  function setSize(root, size) {
    const s = st(root);
    s.size = size;
    s.units.forEach((u) => { u.s = size; });
    root.querySelectorAll('.elv-size[data-size]').forEach((b) => b.classList.toggle('is-active', b.dataset.size === size));
    const name = root.querySelector('[data-elv-size-name]');
    if (name) name.textContent = size;
    root.querySelector('[data-elv-sizes]')?.classList.remove('is-error');
    root.querySelector('.elv-size-err')?.remove();
    syncHiddenId(root);
    renderUnits(root);
  }

  // One colour photo in the gallery: the first colour-photo slot shows the selected colour, the rest are hidden.
  // Slots are tagged once (data-nv-colour = slot | hide) while the gallery is still in theme order.
  function colourMedia(root, jump) {
    const d = dataOf(root);
    const vs = (d.variants || []).filter((v) => v.m > 0 && v.img);
    if (!vs.length) return;
    const section = document.getElementById('shopify-section-' + root.dataset.sectionId);
    if (!section) return;
    const modal = [...document.querySelectorAll('.product-media-modal__content > *')];
    if (!section.dataset.nvColour) {
      const pos = new Set(vs.map((v) => v.m)), slotPos = Math.min(...pos);
      const tag = (els) => els.forEach((el, i) => { const p = i + 1; if (pos.has(p)) el.dataset.nvColour = p === slotPos ? 'slot' : 'hide'; });
      tag([...section.querySelectorAll('li.product__media-item')]);
      tag([...section.querySelectorAll('li.thumbnail-list__item')]);
      tag(modal);
      section.dataset.nvColour = '1';
    }
    const sel = vs.find((v) => v.c === st(root).shade) || vs[0];
    const swap = (el, w) => el && el.querySelectorAll('img').forEach((img) => { const u = sel.img.replace(/width=\d+/, 'width=' + w); if (img.getAttribute('src') !== u) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = u; } });
    [...section.querySelectorAll('[data-nv-colour="hide"]'), ...modal.filter((el) => el.dataset.nvColour === 'hide')].forEach((el) => { el.style.display = 'none'; });
    const slide = section.querySelector('li.product__media-item[data-nv-colour="slot"]');
    const thumb = section.querySelector('li.thumbnail-list__item[data-nv-colour="slot"]');
    swap(slide, 1500); swap(thumb, 416); swap(modal.find((el) => el.dataset.nvColour === 'slot'), 1946);
    if (!jump) return;
    // after a colour pick, the colour photo becomes the first image (top-left on desktop, first slide on mobile)
    if (slide && slide.parentElement.firstElementChild !== slide) slide.parentElement.prepend(slide);
    if (thumb && thumb.parentElement.firstElementChild !== thumb) thumb.parentElement.prepend(thumb);
    section.querySelectorAll('li.product__media-item').forEach((li) => li.classList.toggle('is-active', li === slide));
    if (slide) slide.parentElement.scrollTo({ left: 0, behavior: 'smooth' });
    section.querySelectorAll('li.thumbnail-list__item button').forEach((b) => b.removeAttribute('aria-current'));
    thumb?.querySelector('button')?.setAttribute('aria-current', 'true');
  }

  function setShade(root, shade) {
    const s = st(root);
    s.shade = shade;
    const q = qtyOf(root);
    if (q > 1 && !sized(root)) {
      const a = s.active || 0;
      if (s.units[a]) s.units[a].c = shade;
      s.active = (a + 1) % q;
    } else if (q > 1) {
      // two-option products keep their per-unit selects; the top colour only previews
    } else {
      s.units.forEach((u) => { u.c = shade; });
    }
    root.querySelectorAll('.elv-shade').forEach((b) => b.classList.toggle('is-active', b.dataset.shade === shade));
    const name = root.querySelector('[data-elv-shade-name]');
    if (name) name.textContent = shade;
    syncHiddenId(root);
    renderUnits(root);
    colourMedia(root, true);
  }

  // Top price line follows the selected bundle (total, struck-through value, % saved).
  function renderPrice(root) {
    const bar = selectedBar(root);
    if (!bar || !bar.dataset.priceCents) return;
    const p = Number(bar.dataset.priceCents), c = Number(bar.dataset.compareCents);
    const fmt = (cents) => '$' + (cents / 100).toFixed(2);
    const now = root.querySelector('.elv-price__now'), was = root.querySelector('.elv-price__was'), save = root.querySelector('.elv-price__save');
    if (now) now.textContent = fmt(p);
    if (was) { was.textContent = fmt(c); was.style.display = c > p ? '' : 'none'; }
    if (save) { save.textContent = 'SAVE ' + Math.round((c - p) / c * 100) + '%'; save.style.display = c > p ? '' : 'none'; }
    const section = document.getElementById('shopify-section-' + root.dataset.sectionId);
    if (section) {
      section.querySelectorAll('sticky-atc .price__sale .price-item--sale, sticky-atc .price__regular .price-item--regular').forEach((e) => { e.textContent = fmt(p); });
      section.querySelectorAll('sticky-atc .price__compare-price s').forEach((e) => { e.textContent = fmt(c); });
    }
  }

  function select(root, bar) {
    bars(root).forEach((el) => {
      const on = el === bar;
      el.classList.toggle('kaching-bundles__bar--selected', on);
      const radio = el.querySelector('input[type="radio"]');
      if (radio) radio.checked = on;
    });
    renderPrice(root);
    renderUnits(root);
  }

  function init(root) {
    if (root.dataset.nvInit) return;
    root.dataset.nvInit = '1';
    bars(root).forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); select(root, el); }));
    root.querySelectorAll('.elv-shade').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); setShade(root, b.dataset.shade); }));
    root.querySelectorAll('.elv-size[data-size]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); setSize(root, b.dataset.size); }));
    const dlg = root.querySelector('[data-elv-chart-dialog]'), link = root.querySelector('[data-elv-chart]');
    if (dlg && link) {
      link.hidden = false;
      link.addEventListener('click', (e) => { e.preventDefault(); dlg.showModal(); });
      dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-elv-chart-close]')) dlg.close(); });
    }
    root.addEventListener('change', (e) => {
      const sel = e.target.closest('.elv-pair select');
      if (!sel) return;
      st(root).units[Number(sel.closest('.elv-pair').dataset.i)][sel.dataset.k === 'size' ? 's' : 'c'] = sel.value || null;
      sel.classList.remove('is-error');
    });
    // the pairs box sits after the bars; keep clicks inside it from re-selecting a bar
    root.querySelector('.elv-pairs')?.addEventListener('click', (e) => {
      e.stopPropagation();
      const row = e.target.closest('.elv-pair--dots');
      if (!row) return;
      const s = st(root), i = Number(row.dataset.i), b = e.target.closest('.elv-dot');
      s.active = i;
      if (b) {
        e.preventDefault();
        s.units[i].c = b.dataset.c;
        s.shade = b.dataset.c;   // preview this shade's photo
        root.querySelectorAll('.elv-shade').forEach((x) => x.classList.toggle('is-active', x.dataset.shade === s.shade));
        const name = root.querySelector('[data-elv-shade-name]');
        if (name) name.textContent = s.shade;
        colourMedia(root, true);
      }
      renderUnits(root);
    });
    syncHiddenId(root);
    select(root, selectedBar(root));
    colourMedia(root, false);
  }

  function rootForSection(sectionId) {
    return roots().find((r) => r.dataset.sectionId === sectionId) || roots()[0];
  }
  const isOurs = (root, id) => root && (String(dataOf(root).variant) === String(id) || (dataOf(root).variants || []).some((v) => String(v.id) === String(id)));

  // Every unit needs a size (two-option products). Flags what's missing and returns false.
  function sizesOk(root) {
    if (!sized(root)) return true;
    const s = st(root), q = qtyOf(root);
    if (q < 2) {
      if (s.size) return true;
      const box = root.querySelector('[data-elv-sizes]');
      if (box) {
        box.classList.add('is-error');
        if (!root.querySelector('.elv-size-err')) box.insertAdjacentHTML('afterend', '<p class="elv-size-err">Please choose your size</p>');
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }
    let ok = true;
    s.units.slice(0, q).forEach((u, i) => {
      if (u.s) return;
      ok = false;
      root.querySelector(`.elv-pair[data-i="${i}"] select[data-k="size"]`)?.classList.add('is-error');
    });
    if (!ok) root.querySelector('.elv-pairs')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return ok;
  }
  const NEED_SIZE = () => new Response(JSON.stringify({ status: 422, message: 'Please choose your size', description: 'Please choose your size' }), { status: 422, headers: { 'Content-Type': 'application/json' } });

  // The lines to add for the selected bar: the product (with any gift note) + $0 gift lines.
  function lines(root) {
    const d = dataOf(root), q = qtyOf(root);
    const props = Object.assign({}, ...(d.lineProps || []).filter((p) => q >= p.min).map((p) => p.props));
    let out;
    if (multi(root)) {
      const counts = new Map();
      (q > 1 ? st(root).units.slice(0, q) : [{ c: st(root).shade, s: st(root).size }]).forEach((u) => { const id = idFor(root, u.c, u.s); counts.set(id, (counts.get(id) || 0) + 1); });
      out = [...counts.entries()].map(([id, quantity]) => (Object.keys(props).length ? { id, quantity, properties: props } : { id, quantity }));
    } else {
      const main = { id: d.variant, quantity: q };
      if (Object.keys(props).length) main.properties = props;
      out = [main];
    }
    (d.gifts || []).forEach((g) => { if (g.id && q >= g.min) out.push({ id: g.id, quantity: 1, properties: g.props || {} }); });
    return out;
  }

  // Rewrite the theme's add to cart: our variant, selected bundle quantity.
  const origFetch = window.fetch.bind(window);
  const isAdd = (url) => /\/cart\/add(\.js)?(\?|$)/.test(url);
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (init && init.body && isAdd(url) && roots().length) {
      try {
        if (init.body instanceof FormData) {
          const fd = init.body;
          const id = fd.get('items[0][id]') || fd.get('id');
          const root = rootForSection(fd.get('section-id'));
          if (isOurs(root, id)) {
            if (!sizesOk(root)) return NEED_SIZE();
            [...fd.keys()].filter((k) => k.startsWith('items[')).forEach((k) => fd.delete(k));
            fd.delete('id'); fd.delete('quantity');
            lines(root).forEach((l, i) => {
              fd.append(`items[${i}][id]`, String(l.id)); fd.append(`items[${i}][quantity]`, String(l.quantity));
              Object.entries(l.properties || {}).forEach(([k, v]) => fd.append(`items[${i}][properties][${k}]`, v));
            });
          }
        } else if (typeof init.body === 'string' && init.body.trim().startsWith('{')) {
          const body = JSON.parse(init.body);
          const root = roots()[0];
          const id = body.id || (body.items && body.items[0] && body.items[0].id);
          if (isOurs(root, id)) {
            if (!sizesOk(root)) return NEED_SIZE();
            delete body.id; delete body.quantity;
            body.items = lines(root);
            init = { ...init, body: JSON.stringify(body) };
          }
        }
      } catch (e) { /* fall through to the original request */ }
    }
    return origFetch(input, init);
  };

  // Sticky bar: adds the selected bundle straight to the cart instead of scrolling back up.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.sticky-atc__scroll-btn');
    if (!btn) return;
    const sticky = btn.closest('sticky-atc');
    const section = sticky && document.getElementById('shopify-section-' + sticky.dataset.section);
    const atc = section && section.querySelector('.main-product-atc, button[name="add"]');
    if (!atc) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    atc.click();
  }, true);

  const boot = () => roots().forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
